const Mutations = Object.freeze({
	SET_GRID_VIEWS: 'projectSettings/connectors/SET_GRID_VIEWS',
	SET_SELECTED_GRID_VIEW: 'projectSettings/connectors/SET_SELECTED_GRID_VIEW',
	SET_CONNECTORS: 'projectSettings/connectors/SET_CONNECTORS',
	SET_SELECTED_CONNECTOR: 'projectSettings/connectors/SET_SELECTED_CONNECTOR',
});
export const Actions = Object.freeze({
	CLEAR: 'projectSettings/connectors/CLEAR',
	LOAD_GRIDVIEWS: 'projectSettings/connectors/LOAD_GRIDVIEWS',
});
export const Getters = Object.freeze({
	GRID_VIEWS: 'projectSettings/connectors/GRID_VIEWS',
});

import dataService from '../../../../../../services/data/projectSettingsService';
import { GeneralActions, ConnectorsListActions } from '../../../../../actions';
import connectorsList from './connectorsList';
export default {
	state: {
		gridViews: [],
	},
	mutations: {
		[Mutations.SET_GRID_VIEWS](state, items) {
			state.gridViews = items;
		},
	},
	modules: { connectorsList },
	actions: {
		[Actions.CLEAR]({ commit, dispatch }) {
			return new Promise((resolve) => {
				dispatch(ConnectorsListActions.CLEAR);
				commit(Mutations.SET_GRID_VIEWS, []);
				resolve();
			});
		},
		[Actions.LOAD_GRIDVIEWS]({ commit, dispatch }) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.getGridViews()
					.then((resp) => {
						commit(Mutations.SET_GRID_VIEWS, resp.data);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve();
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
	},
	getters: {
		[Getters.GRID_VIEWS]: (state) => {
			if (state.gridViews && state.gridViews.length > 0) {
				let gridViews = state.gridViews
					.filter((x) => x.Columns.length > 0)
					.sort((a, b) => (a.Name > b.Name ? 1 : -1));
				return JSON.parse(JSON.stringify(gridViews));
			}
			return [];
		},
	},
};
